import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center space-x-6 text-sm">
            <Link
              to="/about"
              className="hover:text-white transition-colors"
            >
              About
            </Link>
            <Link
              to="/disclosure"
              className="hover:text-white transition-colors"
            >
              Disclosure
            </Link>
            <a
              href="https://buymeacoffee.com/amburke"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center hover:text-yellow-400 transition-colors"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.5 3h-17A1.5 1.5 0 002 4.5v15A1.5 1.5 0 003.5 21h17a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0020.5 3zM8 17v-5.5c0-.828.672-1.5 1.5-1.5h5c.828 0 1.5.672 1.5 1.5V17M10 7h.01M14 7h.01" />
              </svg>
              Support this project
            </a>
          </div>
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} BooksForUs. All rights reserved.
          </p>
          <p className="text-sm text-gray-400">
            Made with 📚 and a healthy disregard for convention
          </p>
        </div>
      </div>
    </footer>
  )
}

